import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export type UpdateFileAttachmentMetadataParams = {
  id: string;
  signedId: string;
  isUploaded: boolean;
  isFileReplaced?: boolean;
  fileName?: string;
  fileType?: string;
};

const updateFileAttachmentMetadata = (
  updateFileAttachmentMetadataParams: UpdateFileAttachmentMetadataParams,
): Promise<boolean> =>
  FetchPromise.post(
    `${CMS_API_ROOT_URL}/file/${updateFileAttachmentMetadataParams.id}/metadata`,
    updateFileAttachmentMetadataParams,
  );

export const useUpdateFileAttachmentMetadata = (mutationOptions?: { retry: number }) =>
  useMutation(updateFileAttachmentMetadata, mutationOptions);
